import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinWithHyphens',
  standalone: true
})
export class JoinWithHyphensPipe implements PipeTransform {
  /** Replace a string's spaces with hyphens */
  transform(
    value: string
  ): string {
    return value.split(' ').join('-');
  }
}
